/**
 * Created by guhaikuan on 2020/7/31
 */
import request, { abortRequest } from './request';
import qs from 'qs';
import Cookies from 'js-cookie';
import DeviceInfo from '../DeviceInfo';
import { mockMaxVersion } from '../QPInfoManager';
var uniqueId = 1;
var HOTDOG_CALLBACK_NAME = 'RNHotDogCallBack';
var SUCCESS_KEY = 'success';
var FAILED__KEY = 'fail';
var CACHE__KEY = 'cache';
var TYPE_KEY = 'type';
var CANCEL_KEY = 'cancel';
var PARAM_ERROR_CODE = 10004;
var TIMEOUT_ERROR_CODE = 10008;
var CALLBACKID_KEY = 'callBackID';
var RESPONSRE_KEY = 'response';
var GET = 'GET';
var POST = 'POST';
var SERVICETYPE_PARAMETER = 'serviceType';
var URL_PARAMETER = 'url';
var PARAM_PARAMETER = 'param';
var METHOD_PARAMETER = 'method';
var REQUEST_TYPE_PARAMETER = 'requestType';
var RESPONSE_TYPE_PARAMETER = 'responseType';
var USERCACHE_PARAMETER = 'useCache';
var CACHEKEY_PARAMETER = 'cacheKey';
var TIMEOUT_PARAMETER = 'timeout';
var SUCCESSCALLBACK_PARAMETER = 'successCallback';
var FAILCALLBACK_PARAMETER = 'failCallback';
var CACHECALLBACK_PARAMETER = 'cacheCallback';
var VERSION_PARAMETER = 'version';
var SERIALIZE_PARAMETER = 'serialize';
var TIMING_KEY = 'timing';
var TIMING_JSREQ_START = 'jsReqStart';
var TIMING_JSREQ_CALLBACK = 'jsReqCallBack';
var requestMap = {};
var QHotDogNetWork = {
  postRequest: function postRequest(parameter) {
    if (!parameter) {
      if (__DEV__) {
        throw '请求参数不能为空';
      }

      return;
    }

    var self = this;
    var serviceType, url, param, method, requestType, responseType, useCache, cacheKey, timeout, successCallback, failCallback, cacheCallback, serialize, bParamStr, cParamStr;
    var qpVersion = parameter[VERSION_PARAMETER];
    serviceType = parameter[SERVICETYPE_PARAMETER];
    url = parameter[URL_PARAMETER];
    var _parameter$statics = parameter.statics,
        statics = _parameter$statics === void 0 ? false : _parameter$statics;
    param = parameter[PARAM_PARAMETER];
    method = parameter[METHOD_PARAMETER];
    requestType = parameter[REQUEST_TYPE_PARAMETER];
    responseType = parameter[RESPONSE_TYPE_PARAMETER];
    useCache = !!parameter[USERCACHE_PARAMETER];
    cacheKey = parameter[CACHEKEY_PARAMETER];
    timeout = parameter[TIMEOUT_PARAMETER];
    serialize = true;

    if (parameter[SERIALIZE_PARAMETER] !== undefined) {
      serialize = !!parameter[SERIALIZE_PARAMETER];
    }

    successCallback = parameter[SUCCESSCALLBACK_PARAMETER];
    failCallback = parameter[FAILCALLBACK_PARAMETER];
    cacheCallback = parameter[CACHECALLBACK_PARAMETER];

    if (!url) {
      throw new Error('[QRN-Web]: 在 QRN-Web 上 QHotDogNetWork 必须指定 url 才能工作');
    } // if(method.toUpperCase() === GET){
    //     const queryString = url.indexOf('?') > 0 ? url.split('?')[1] : ''
    //     const queryObj = qs.parse(queryString)
    //     const bParam = {...queryObj, ...param}
    //     param.qrt = bParam.t
    //     bParamStr = JSON.stringify(bParam)
    // }else{
    //     param.qrt = param.t
    //     bParamStr = JSON.stringify(param)
    // }
    // // 从设备获取到的c参
    // const originCParamObj = {
    //     cid: DeviceInfo.cid,
    //     pid: DeviceInfo.pid,
    //     gid: DeviceInfo.gid,
    //     uid: DeviceInfo.uid,
    //     vid: DeviceInfo.vid,
    //     osVersion: DeviceInfo.osVersion,
    //     model: DeviceInfo.model,
    //     mac: DeviceInfo.mac,
    //     t: param.qrt,
    //     un: Cookies.get('_q')?.replace('U.', ''),
    //     usid: '',
    //     ip: '',
    //     port: '',
    //     mno: '',
    //     nt: '',
    //     lat: '',
    //     lgt: '',
    //     atomId: '',
    //     qpVersion: mockMaxVersion
    // }
    // param.b = bParamStr
    // param.c = JSON.stringify({...originCParamObj, ...param.c})
    // console.log('param', param)


    if (useCache == true) {
      if (!cacheKey) {
        if (__DEV__) {
          throw '如果useCache为YES，则cacheKey不能为空';
        }

        var errorMap = {};
        errorMap['errorCode'] = PARAM_ERROR_CODE;
        errorMap['reason'] = '如果useCache为YES，则cacheKey不能为空';
        failCallback(errorMap);
        return;
      }
    }

    var hasReturn = false;
    var version = 0; // 有用户设置的用用户设置的

    if (qpVersion) {
      version = qpVersion;
    }

    var _request = request({
      url: url,
      method: method,
      body: param,
      requestType: requestType,
      responseType: responseType,
      timeout: 5000
    }),
        promise = _request.promise,
        requestId = _request.requestId;

    promise.then(function (res) {
      successCallback && successCallback(res);
      hasReturn = true;
    })["catch"](function (err) {
      failCallback && failCallback(err);
      hasReturn = true;
    });

    if (timeout > 0) {
      setTimeout(function () {
        if (!hasReturn) {
          var _errorMap = {};
          _errorMap["errorCode"] = TIMEOUT_ERROR_CODE;
          _errorMap["reason"] = "请求超时";
          failCallback(_errorMap);
        }
      }, timeout);
    }

    return requestId;
  },
  cancelNetWorkTask: function cancelNetWorkTask(requestId) {
    abortRequest(requestId);
  }
};
export default QHotDogNetWork;